var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjamIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0001 1.47876L37.9051 11.2403V30.7598L21.0001 40.5213L4.09509 30.7598V11.2403L21.0001 1.47876ZM21.0001 5.52126L7.59509 13.2598V28.7403L21.0001 36.4788L34.4051 28.7403V13.2598L21.0001 5.52126Z",
    fill: "#010101"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0156 18.7031C22.7668 18.0072 25.812 15.8288 26.9062 14.7656C26.9062 19.6875 25.6589 22.4672 24.9375 23.2969C21.6562 27.0703 18.0683 25.3178 17.3906 23.9531C15.7976 20.7451 18.0698 19.1953 20.0156 18.7031Z",
    fill: "#60A630",
    stroke: "#010101",
    strokeWidth: 1.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0938 27.2344C15.2289 26.5781 15.8774 25.0688 17.3906 24.2812L15.0938 27.2344Z",
    fill: "#00AC56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0938 27.2344C15.2289 26.5781 15.8774 25.0688 17.3906 24.2812",
    stroke: "#010101",
    strokeWidth: 1.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjamIcon);
export default __webpack_public_path__ + "static/media/projam-icon.b57cb201e64a329ee50548be74332028.svg";
export { ForwardRef as ReactComponent };